import loadScript from '../util/loader';

export default async function productNativeVideo(uniqueKey) {
  const playerElement = document.querySelector(`[data-player="${uniqueKey}"]`);
  const videoElement = playerElement.querySelector('video');
  const videoLoad = {
    name: 'video-ui',
    version: '1.0',
  };
  await loadScript(videoLoad);

  const player = new window.Shopify.Plyr(videoElement);
  playerElement.addEventListener('pause', () => {
    if (player.pause) {
      player.pause();
    }
  });
  playerElement.addEventListener('play', () => {
    try {
      if (player.play) {
        // Check if it is paused to avoid playing an already playing video which sometimes results in error
        if (player.paused) {
          player.play();
        }
      } else {
        player.addEventListener('onReady', () => {
          player.play();
        });
      }
    } catch (e) {
      console.warn(e);
    }
  });
  playerElement.addEventListener('destroy', () => {
    try {
      if (player.destroy) {
        player.destroy();
      }
    } catch (e) {
      console.warn(e);
    }
  });
  return player;
}
